import React, { Component, useEffect, useState } from 'react';
import { Steps } from 'antd'
import { Progress } from 'antd';
const { Step } = Steps
import VehicleMakeModelImage from './VehicleMakeModelImage';
import { cdnDomain } from '../utilities/config';
const screenWidth = window.screen.width
import(/* webpackPrefetch: true */'antd/dist/antd.css')
import PropTypes from 'prop-types';
import { productTypes } from '../utilities/enums';

import building_content_graphic from '../../assets/images/buildings-and-contents-graphic.png'

const ProgressStepIndicator = (props) => {
  const {
    product,
    progressTotal,
    step,
    vehicleExists = false,
    iwyzePersonExists = false,
    quoteError = false,
    showVehicleImage = false,
    showProgressSteps = true,
  } = props;

  const [vehicleDetailsStepIsComplete, setVehicleDetailsStepIsComplete] = useState(false)
  const [personalDetailsStepIsComplete, setPersonalDetailsStepIsComplete] = useState(false)
  const [isQuoteError, setIsQuoteError] = useState(false)
  const [showVehicleBrand, setShowVehicleBrand] = useState(false)

  useEffect(() => {
    setVehicleDetailsStepIsComplete(vehicleExists)
    setPersonalDetailsStepIsComplete(iwyzePersonExists)
    setIsQuoteError(quoteError)
    setShowVehicleBrand(showVehicleImage)
  }, [vehicleExists, iwyzePersonExists, quoteError, showVehicleImage])

  let stepData;

  if (product === productTypes.motor) {
    stepData = [
      {
        title: 'Vehicle Details',
        description: '40 Secs',
        status: vehicleDetailsStepIsComplete ? 'finish' : ''
      },
      {
        title: 'Personal Details',
        description: '30 Secs',
        status: personalDetailsStepIsComplete ? 'finish' : ''
      },
      {
        title: 'Quote',
        description: '10 Secs',
        status: isQuoteError ? 'error' : ''

      },
      {
        title: 'Payment',
        description: '10 Secs',
        status: 'wait'
      }
    ];
  }
  else if (product === productTypes.homeContents) {
    stepData = [
      {
        title: 'Personal Details',
        description: '10 seconds'
      },
      {
        title: 'Home Details',
        description: '20 seconds'
      },
      {
        title: 'Approve Quote',
        description: '10 seconds'
      },
      {
        title: 'Make Payment',
        description: '10 seconds'
      }
    ]
  };

  stepData.forEach(step => {
    step.title = <p className='step-label'>{step.title}</p>;
    step.description = <p className='step-sub-label'>{step.description}</p>
  });

  return (
    <div className='progress-step-indicator-wrapper'>
      {
        product === productTypes.motor && (
          showVehicleBrand ?
            <div className='progress-step-indicator-image-wrapper'>
              <VehicleMakeModelImage />
            </div>
            :
            <div className='progress-step-indicator-video-wrapper'>
              {
                screenWidth > 468 &&
                <video loop={true} autoPlay="autoplay" muted>
                  <source src={`${cdnDomain}/static/videos/car-morph-small.mp4`} type="video/mp4" />
                </video>
              }
            </div>
        )
      }
      {
        product === productTypes.homeContents &&
        <div className='progress-step-indicator-image-wrapper'>
          <img src={building_content_graphic} alt='a picture of a home' />
        </div>
      }
      {
        showProgressSteps &&
        <div className='progress-step-indicator-data-wrapper'>
          <div className='progress-step-indicator-steps-wrapper'>
            <Steps
              className='step-bar'
              responsive={false}
              current={step}
              labelPlacement="vertical"
              items={stepData}
              //percent={progressCurrentPage}
            >
              <Step status={vehicleDetailsStepIsComplete ? 'finish' : ''} title={<p className='step-label'>Vehicle Details</p>} subTitle={<p className='step-sub-label'>40 Secs</p>} />
              <Step status={personalDetailsStepIsComplete ? 'finish' : ''} title={<p className='step-label'>Personal Details</p>} subTitle={<p className='step-sub-label'>30 Secs</p>} />
              <Step status={isQuoteError ? 'error' : ''} title={<p className='step-label'>Quote</p>} subTitle={<p className='step-sub-label'>10 Secs</p>} />
              <Step title={<p className='step-label'>Payment</p>} subTitle={<p className='step-sub-label'>10 Secs</p>} />
            </Steps>
          </div>
          <div className='progress-step-indicator-progress-wrapper'>
            <Progress
              strokeLinecap='round'
              // strokeColor="#68C9D0"
              // trailColor="#e2e2e2"
              percent={progressTotal}
              strokeWidth={15}
              strokeColor={'#68C9D0'}
            />
          </div>
        </div>
      }
    </div>
  )
}

ProgressStepIndicator.propTypes = {
  product: PropTypes.oneOf([productTypes.motor, productTypes.homeContents]).isRequired,
  progressTotal: PropTypes.number,
  step: PropTypes.number.isRequired,
  showProgressSteps: PropTypes.bool,
  vehicleExists: PropTypes.bool,
  iwyzePersonExists: PropTypes.bool,
  quoteError: PropTypes.bool,
  showVehicleImage: PropTypes.bool
};

// Specifies the default values for props:
ProgressStepIndicator.defaultProps = {
  showProgressSteps: true,
  vehicleExists: false,
  iwyzePersonExists: false,
  quoteError: false,
  showVehicleImage: false
};

export default ProgressStepIndicator;
